export default "/_next/static/8ca995f88673a18304e318cd935b6066.png";